export default __webpack_public_path__ + "static/media/fbx_banner.8071478e.jpeg";